module.exports = __webpack_public_path__ + "img/sleep.3a272c86.svg";